<script>
  export default{
    props: ['mensagem'],
    name: 'chat-conversa-mensagem-terceiro',
    data () {
      return {}
    },
    computed: {},
    mounted () {},
    destroyed () {},
    methods: {},
    components: {}
  }
</script>

<template>
  <div class="mensagemTerceiro" :class="{'m-b': mensagem.showAvatar}">
    <a class="avatar" v-if="mensagem.showAvatar">
      <img width="32" src="~assets/img/user-default.png" :alt="mensagem.remetente.nome">
    </a>
    <span class="avatar" v-else></span>
    <p class="msg" :class="{startMessage: mensagem.startMessage, break: mensagem.showAvatar && !mensagem.startMessage, continue: !mensagem.showAvatar}">{{ mensagem.mensagem }}</p>
      <!--<small class="text-muted m-l-sm"><i class="fas fa-ok text-success"></i> {{ mensagem.data.date | moment }}
      </small>-->

  </div>
</template>

<style lang="scss">
  .mensagemTerceiro {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    line-height: 1.28;
    padding: 0 0 1px 0;
    text-align: initial;
    .avatar{
      flex: 0;
      min-width: 32px;
      width: 32px;
      margin-right: 10px;
    }
    .msg{
      background: #f2f2f2;
      padding: 5px 8px 6px;
      color: #333333;
      font-weight: normal;
      max-width: 150px;
      word-wrap: break-word;
      border-radius: 20px 20px 20px 0;
      margin: 0;
      &.continue{
        border-radius: 0 20px 20px 0;
      }
      &.break{
        border-radius: 0 20px 20px 20px;
      }
      &.startMessage{
        border-radius: 20px 20px 20px 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ChatConversaMensagemTerceiro.vue?1b298966